import moment from 'moment';
export const registroFornecedor = {
  content: [
    {
      id: '1',
      pessoa: {
        nome: 'Fornecedor 1',
        pessoaJuridica: {
          cnpj: '70414896000130',
          razaoSocial: 'Fornecedor ltda',
        },
        contatos: [
          {
            numero: '8136965324',
          },
        ],
      },
    },
    {
      id: '2',
      pessoa: {
        nome: 'Fornecedor 2',
        pessoaFisica: {
          cpf: '93394584433',
        },
        contatos: [
          {
            numero: '2827096384',
          },
        ],
      },
    },
    {
      id: '3',
      pessoa: {
        nome: 'Fornecedor 3',
        pessoaFisica: {
          cpf: '86581622656',
        },
        contatos: [
          {
            numero: '61993242766',
          },
        ],
      },
    },
  ],
  first: true,
  last: true,
  number: 0,
  size: 15,
  sort: 'pessoa.nome,asc',
  totalElements: 3,
  totalPages: 1,
};

export const registroCliente = {
  content: [
    {
      cpf: '40779425006',
      id: '1',
      nome: 'Cliente 1',
      pessoaId: '1',
      telefonePrincipal: '8229287799',
      tipoPessoa: 'FISICA',
    },
    {
      cpf: '78250897820',
      id: '2',
      nome: 'Cliente 2',
      pessoaId: '2',
      telefonePrincipal: '8537720724',
      razaoSocial: 'Cliente LTDA',
      tipoPessoa: 'JURIDICA',
    },
    {
      cpf: '45382028001',
      id: '3',
      nome: 'Cliente 3',
      pessoaId: '3',
      telefonePrincipal: '85995963156',
      tipoPessoa: 'FISICA',
    },
  ],
  first: true,
  last: true,
  number: 0,
  size: 15,
  sort: 'pessoa.nome,asc',
  totalElements: 1,
  totalPages: 1,
};

export const registroTransportadora = {
  content: [
    {
      id: '1',
      pessoa: {
        nome: 'Transportadora 1',
        pessoaJuridica: {
          cnpj: '70414896000130',
        },
      },
      contatos: [
        {
          numero: '8136965324',
        },
      ],
    },
    {
      id: '2',
      pessoa: {
        nome: 'Transportadora 2',
        pessoaJuridica: {
          cnpj: '48909205000110',
        },
        contatos: [
          {
            numero: '2827096384',
          },
        ],
      },
    },
    {
      id: '3',
      pessoa: {
        nome: 'Transportadora 3',
        pessoaJuridica: {
          cnpj: '51972282000120',
        },
        contatos: [
          {
            numero: '61993242766',
          },
        ],
      },
    },
  ],
  first: true,
  last: true,
  number: 0,
  size: 15,
  sort: 'pessoa.nome,asc',
  totalElements: 3,
  totalPages: 1,
};

export const registroImposto = {
  content: [
    {
      id: '1',
      aliquota: '1',
      codigo: '1',
      nome: 'Imposto 1',
      fornecedor: {
        pessoa: {
          nome: 'Fornecedor 1',
        },
      },
      tipo: 'DARF',
    },
    {
      id: '2',
      aliquota: '2',
      codigo: '2',
      nome: 'Imposto 2',
      fornecedor: {
        pessoa: {
          nome: 'Fornecedor 2',
        },
      },
      tipo: 'GPS',
    },
    {
      id: '3',
      aliquota: '3',
      codigo: '3',
      nome: 'Imposto 3',
      fornecedor: {
        pessoa: {
          nome: 'Fornecedor 3',
        },
      },
      tipo: 'OUTROS',
    },
    {
      id: '4',
      aliquota: '4',
      codigo: '4',
      nome: 'Imposto 4',
      fornecedor: {
        pessoa: {
          nome: 'Fornecedor 4',
        },
      },
      tipo: 'IBSCBS',
    },
  ],
  first: true,
  last: true,
  number: 0,
  size: 15,
  sort: 'nome,asc',
  totalElements: 4,
  totalPages: 1,
};

export const registroTransferencia = {
  content: [
    {
      id: '1',
      origem: 'Conta origem 1',
      destino: 'Conta destino 1',
      valor: 100,
      data: '2023-04-01',
      descricao: 'Exemplo 1',
    },
    {
      id: '2',
      origem: 'Conta origem 2',
      destino: 'Conta destino 2',
      valor: 200,
      data: '2023-05-01',
      descricao: 'Exemplo 2',
    },
    {
      id: '3',
      origem: 'Conta origem 3',
      destino: 'Conta destino 3',
      valor: 300,
      data: '2023-06-01',
      descricao: 'Exemplo 3',
    },
  ],
  first: true,
  last: true,
  number: 0,
  size: 15,
  sort: '',
  totalElements: 3,
  totalPages: 1,
};

export const registroOrdemServico = {
  content: [
    {
      id: '1',
      identificador: '001',
      cliente: {
        pessoa: {
          nome: '-',
        },
      },
      tecnicoResponsavel: '-',
      situacao: 'EM_ANDAMENTO',
    },
    {
      id: '2',
      identificador: '002',
      cliente: {
        pessoa: {
          nome: '-',
        },
      },
      tecnicoResponsavel: '-',
      situacao: 'PENDENTE',
    },
    {
      id: '3',
      identificador: '003',
      cliente: {
        pessoa: {
          nome: '-',
        },
      },
      tecnicoResponsavel: '-',
      situacao: 'CONCLUIDO',
    },
  ],
  first: true,
  last: true,
  number: 0,
  size: 15,
  sort: 'identificador: DESC',
  totalElements: 2,
  totalPages: 1,
};

export const registroContrato = {
  content: [
    {
      id: '1',
      identificador: '01',
      dataVigenciaInicial: '2023-01-01',
      dataVigenciaFinal: '2023-12-31',
      nomeCliente: 'Cliente 1',
      valor: 1200,
      situacao: 'ATIVO',
    },
    {
      id: '2',
      identificador: '02',
      dataVigenciaInicial: '2023-01-01',
      dataVigenciaFinal: '2023-12-31',
      nomeCliente: 'Cliente 2',
      valor: 1100,
      situacao: 'ATIVO',
    },
    {
      id: '3',
      identificador: '03',
      dataVigenciaInicial: '2023-01-01',
      dataVigenciaFinal: '2023-12-31',
      nomeCliente: 'Cliente 3',
      valor: 1000,
      situacao: 'ATIVO',
    },
  ],
  first: true,
  last: true,
  number: 0,
  size: 15,
  sort: 'cliente.pessoa.nome,asc',
  totalElements: 2,
  totalPages: 1,
};

export const registroFaturamento = {
  lanes: [
    {
      id: 'faturamentoPendente',
      tituloLane: 'Faturamentos pendentes',
      helper: 'Contratos e vendas com faturamento previstos no mês do filtro',
      menu: false,
      cards: [
        {
          botaoCancelarNf: false,
          botaoEditarVenda: true,
          botaoExcluirVenda: true,
          botaoEnviarNfEmail: false,
          botaoVisualizarNf: false,
          cancelamentoErros: false,
          emCancelamento: false,
          faturamentoErros: false,
          id: '1',
          laneId: 'faturamentoPendente',
          mensagemCancelamento: false,
          mesCompetencia: Date.now(),
          status: 'FATURAMENTO_PENDENTE',
          subtitulo: 'Cliente 1',
          tipo: 'VENDA',
          tipoEmissaoNota: 'SERVICO',
          titulo: 'Venda 1',
          valor: 1200,
          visible: true,
        },
      ],
    },
    {
      id: 'faturar',
      tituloLane: 'A faturar',
      helper: 'Contratos e vendas aguardando início do faturamento no mês do filtro',
      menu: true,
      cards: [
        {
          botaoCancelarNf: false,
          botaoEditarVenda: true,
          botaoExcluirVenda: true,
          botaoEnviarNfEmail: false,
          botaoVisualizarNf: false,
          cancelamentoErros: false,
          emCancelamento: false,
          faturamentoErros: false,
          id: '2',
          laneId: 'faturar',
          mensagemCancelamento: false,
          mesCompetencia: Date.now(),
          status: 'A_FATURAR',
          subtitulo: 'Cliente 2',
          tipo: 'VENDA',
          tipoEmissaoNota: 'SERVICO',
          titulo: 'Venda 1',
          valor: 1200,
          visible: true,
        },
      ],
    },
    {
      id: 'emFaturamento',
      tituloLane: 'Em faturamento',
      helper: 'Contratos e vendas com Notas Fiscais transmitidas para prefeitura/SEFAZ e aguardam confirmação',
      menu: false,
      cards: [
        {
          botaoCancelarNf: false,
          botaoEditarContrato: true,
          botaoEnviarNfEmail: false,
          botaoVisualizarNf: false,
          cancelamentoErros: false,
          emCancelamento: false,
          faturamentoErros: false,
          id: '3',
          laneId: 'emFaturamento',
          mensagemCancelamento: false,
          mesCompetencia: Date.now(),
          status: 'EM_FATURAMENTO',
          subtitulo: 'Cliente 1',
          tipo: 'CONTRATO',
          tipoEmissaoNota: 'SERVICO',
          titulo: 'Contrato 3',
          valor: 1200,
          visible: true,
        },
      ],
    },
    {
      id: 'faturado',
      tituloLane: 'Faturado',
      helper: 'Contratos e vendas com Nota Fiscal emitida ou cancelada',
      menu: false,
      cards: [
        {
          botaoCancelarNf: false,
          botaoEditarContrato: true,
          botaoEnviarNfEmail: false,
          botaoVisualizarNf: false,
          cancelamentoErros: false,
          emCancelamento: false,
          faturamentoErros: false,
          id: '4',
          laneId: 'faturado',
          mensagemCancelamento: false,
          mesCompetencia: Date.now(),
          status: 'FATURADO',
          subtitulo: 'Cliente 4',
          tipo: 'CONTRATO',
          tipoEmissaoNota: 'SERVICO',
          titulo: 'Contrato 4',
          valor: 1200,
          visible: true,
        },
      ],
    },
  ],
};

export const servicosTour = [
  { id: '1', descricao: 'Serviço 01', codigo: 'SERV-01', valorCusto: '10', valorVenda: '15' },
  { id: '2', descricao: 'Serviço 02', codigo: 'SERV-02', valorCusto: '20', valorVenda: '25' },
  { id: '3', descricao: 'Serviço 03', codigo: 'SERV-03', valorCusto: '30', valorVenda: '35' },
];

export const produtosTour = [
  { id: '1', nome: 'Produto 01', codigo: 'PROD-01', quantidadeEstoque: 1, valorUnitario: 100 },
  { id: '2', nome: 'Produto 02', codigo: 'PROD-02', quantidadeEstoque: 2, valorUnitario: 200 },
  { id: '3', nome: 'Produto 03', codigo: 'PROD-03', quantidadeEstoque: 3, valorUnitario: 300 },
];

export const comprasTour = [
  {
    id: '1',
    dataCompra: moment(),
    nome: 'Compra 01',
    compraId: '001',
    fornecedor: {
      pessoa: {
        nome: 'Fornecedor 01',
      },
    },
    vencimento: moment(),
    condicaoPagamento: 'A vista',
    valorTotal: 100,
  },
  {
    id: '2',
    dataCompra: moment(),
    nome: 'Compra 02',
    compraId: '002',
    fornecedor: {
      pessoa: {
        nome: 'Fornecedor 02',
      },
    },
    vencimento: moment(),
    condicaoPagamento: 'A vista',
    valorTotal: 200,
  },
  {
    id: '3',
    dataCompra: moment(),
    nome: 'Compra 03',
    compraId: '003',
    fornecedor: {
      pessoa: {
        nome: 'Fornecedor 03',
      },
    },
    vencimento: moment(),
    condicaoPagamento: 'A vista',
    valorTotal: 300,
  },
];

export const vendasTour = [
  {
    id: '1',
    data: moment(),
    identificador: '001',
    nomeCliente: 'Cliente 01',
    valor: 100,
    situacao: 'VENDA_APROVADA',
  },
  {
    id: '2',
    data: moment(),
    identificador: '002',
    nomeCliente: 'Cliente 02',
    valor: 200,
    situacao: 'ORCAMENTO_RECUSADO',
  },
  {
    id: '3',
    data: moment(),
    identificador: '003',
    nomeCliente: 'Cliente 03',
    valor: 300,
    situacao: 'EM_ORCAMENTO',
  },
];

export const contasPagarTour = {
  content: [
    {
      id: '1',
      categorias: [
        {
          classe: {
            indice: '2.1.1',
            nome: 'Salários',
          },
        },
      ],
      fornecedor: {
        pessoa: {
          nome: 'Fornecedor 01',
        },
      },
      valorLiquido: 100,
      dataVencimento: moment(),
      competencia: moment(),
    },
    {
      id: '2',
      categorias: [
        {
          classe: {
            indice: '2.1.1',
            nome: 'Salários',
          },
        },
      ],
      fornecedor: {
        pessoa: {
          nome: 'Fornecedor 02',
        },
      },
      valorLiquido: 200,
      dataVencimento: moment(),
      competencia: moment(),
    },
    {
      id: '3',
      categorias: [
        {
          classe: {
            indice: '2.1.1',
            nome: 'Salários',
          },
        },
      ],
      fornecedor: {
        pessoa: {
          nome: 'Fornecedor 03',
        },
      },
      valorLiquido: 300,
      dataVencimento: moment(),
      competencia: moment(),
    },
  ],
};

export const mockTourContaReceber = [
  {
    id: '1',
    tipo: 'UNICA',
    nomeCliente: 'Cliente 01',
    mesCompetencia: Date.now(),
    dataVencimento: Date.now(),
    situacaoRemessa: 'NAO_TRATADA_BANCO',
    valor: 500,
    situacao: 'ABERTA',
  },
  {
    id: '2',
    tipo: 'UNICA',
    nomeCliente: 'Cliente 02',
    mesCompetencia: Date.now(),
    dataVencimento: Date.now(),
    situacaoRemessa: 'NAO_TRATADA_BANCO',
    valor: 500,
    situacao: 'ABERTA',
  },
  {
    id: '3',
    tipo: 'UNICA',
    nomeCliente: 'Cliente 03',
    mesCompetencia: Date.now(),
    dataVencimento: Date.now(),
    situacaoRemessa: 'NAO_TRATADA_BANCO',
    valor: 500,
    situacao: 'ABERTA',
  },
];

export const mockEstoqueTour = [
  {
    id: '1',
    codigo: 1,
    nome: 'Produto 01',
    quantidadeEstoque: 1,
    valorUnitario: 50,
  },
  {
    id: '2',
    codigo: 2,
    nome: 'Produto 02',
    quantidadeEstoque: 1,
    valorUnitario: 50,
  },
  {
    id: '3',
    codigo: 3,
    nome: 'Produto 03',
    quantidadeEstoque: 1,
    valorUnitario: 50,
  },
];

export const registroReguaCobranca = {
  content: [
    {
      id: 1,
      empresaId: 'a47ca629-cd64-4442-949c-3988e87cde47',
      nome: 'Régua de cobrança 01',
      clientId: '4e5f96a7-66ec-4601-aaa4-11bcd08a829b',
      grupoClienteId: '0ca5beb2-df18-4c65-ae91-9b27a2e9f736',
    },
    {
      id: 2,
      empresaId: 'a47ca629-cd64-4442-949c-3988e87cde47',
      nome: 'Régua de cobrança 02',
      clientId: 'e83efae1-6cea-46fb-87c3-6214342bc3da',
      grupoClienteId: '0ca5beb2-df18-4c65-ae91-9b27a2e9f736',
    },
    {
      id: 3,
      empresaId: 'a47ca629-cd64-4442-949c-3988e87cde47',
      nome: 'Régua de cobrança 03',
      clientId: '4e5f96a7-66ec-4601-aaa4-11bcd08a829b',
      grupoClienteId: '0ca5beb2-df18-4c65-ae91-9b27a2e9f736',
    },
  ],
  number: 0,
  size: 15,
  sort: 'nome,DESC',
  totalElements: 3,
};

export const acompanharReguaCobranca = {
  content: [
    {
      id: 1,
      descricao: 'Email enviado.',
      dias: 5,
      tipoPasso: 'LEMBRETE_VENCIMENTO',
      acoes: ['EMAIL'],
    },
    {
      id: 2,
      descricao: 'SMS enviado.',
      dias: 1,
      tipoPasso: 'COBRANCA_APOS_VENCIMENTO',
      acoes: ['SMS'],
    },
  ],
};
